import React from 'react'
import dayjs from 'dayjs'
import {Stack, ToggleButton, ToggleButtonGroup, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useGetMeterReadingDashboardQuery} from 'store/Store'
import RateChip from 'components/Page/Dashboard/RateChip'

const DashboardHeader = ({category, categories, onCategoryChange}) => {
    const {t} = useTranslation()
    const {data} = useGetMeterReadingDashboardQuery({category})
    const lastUpdated = data?.summary?.lastUpdated

    return (
        <Stack
            direction={{xs: 'column', md: 'row'}}
            justifyContent="space-between"
            alignItems={{xs: 'flex-start', md: 'center'}}
            gap={2}>
            <Stack spacing={0.25}>
                <Typography variant="h4" fontWeight={700}>
                    {t('side_menu.dashboard')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {lastUpdated
                        ? t('dashboard.lastReading', {time: dayjs(lastUpdated).format('HH:mm')})
                        : t('dashboard.subtitle')}
                </Typography>
            </Stack>
            <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
                <RateChip category={category} />
                {categories.length > 1 && (
                    <ToggleButtonGroup
                        exclusive
                        size="small"
                        value={category}
                        onChange={(_event, next) => next && onCategoryChange(next)}>
                        {categories.map((value) => (
                            <ToggleButton key={value} value={value} sx={{textTransform: 'none'}}>
                                {t(`selectOptions.${value}`)}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                )}
            </Stack>
        </Stack>
    )
}

export default DashboardHeader
